'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagGuAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "#DE3149" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M25.6667 1.33333H2.33337C1.78109 1.33333 1.33337 1.78105 1.33337 2.33333V17.6667C1.33337 18.219 1.78109 18.6667 2.33337 18.6667H25.6667C26.219 18.6667 26.6667 18.219 26.6667 17.6667V2.33333C26.6667 1.78105 26.219 1.33333 25.6667 1.33333Z",
          fill: "#053B94"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 16C14 16 18 13.3137 18 10C18 6.68629 14 4 14 4C14 4 10 6.68629 10 10C10 13.3137 14 16 14 16Z",
          fill: "#DE3149"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14 15.3333C14 15.3333 17.3334 12.6667 17.3334 10C17.3334 7.33333 14 4.66667 14 4.66667C14 4.66667 10.6667 7.33333 10.6667 10C10.6667 12.6667 14 15.3333 14 15.3333Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14 15.3333C14 15.3333 17.3334 12.6667 17.3334 10C17.3334 7.33333 14 4.66667 14 4.66667C14 4.66667 10.6667 7.33333 10.6667 10C10.6667 12.6667 14 15.3333 14 15.3333Z",
          fill: "#81C1F3"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M10.7326 10.6666C11.2003 13.0935 14 15.3333 14 15.3333C14 15.3333 16.7998 13.0935 17.2675 10.6666H10.7326Z",
          fill: "#FFF048"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M16.7612 12.0587C17.102 11.405 17.3334 10.7025 17.3334 10C17.3334 7.33333 14 4.66667 14 4.66667C14 4.66667 10.6667 7.33333 10.6667 10C10.6667 11.0745 11.2078 12.149 11.8541 13.049C12.4368 13.5321 13.0692 14 13.3333 14C13.6871 14 13.8516 13.7151 14.036 13.3958C14.1909 13.1276 14.3598 12.8351 14.6667 12.6667C15.3255 12.305 16.1969 12.1353 16.7612 12.0587Z",
          fill: "#053B94"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.0818 11.3338C17.2389 10.8977 17.3334 10.4488 17.3334 10C17.3334 7.33333 14 4.66667 14 4.66667C14 4.66667 10.6667 7.33333 10.6667 10C10.6667 10.636 10.8562 11.2719 11.145 11.8717C11.7146 11.7236 12.6347 11.5 12.9999 11.5C13.1782 11.5 13.471 11.5277 13.8159 11.5603C14.7304 11.6468 16.0118 11.768 16.4999 11.5C16.7681 11.3528 16.9539 11.3123 17.0818 11.3338Z",
          fill: "#81C1F3"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.0002 9.46665L12.8246 10.2847L13.2393 8.91386L12.098 8.04861L13.5299 8.01943L14.0002 6.66665L14.4704 8.01943L15.9023 8.04861L14.761 8.91386L15.1757 10.2847L14.0002 9.46665Z",
          fill: "#27A07E"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.6682 8.63337C13.6565 8.75031 13.6391 8.949 13.6216 9.19749C13.6004 9.50031 13.5852 9.79889 13.5786 10.0793C13.564 10.7012 13.5912 11.1614 13.6837 11.4388C13.7998 11.7871 14.0624 12.114 14.4262 12.4275C14.7041 12.6671 14.9796 12.8499 15.1694 12.957C15.3298 13.0475 15.5331 12.9908 15.6236 12.8305C15.714 12.6701 15.6574 12.4668 15.497 12.3764C15.3422 12.289 15.1006 12.1287 14.8614 11.9226C14.5806 11.6804 14.3864 11.4388 14.3161 11.2279C14.2566 11.0495 14.2323 10.6385 14.2451 10.0949C14.2514 9.82594 14.2661 9.53733 14.2867 9.24409C14.3036 9.00293 14.3204 8.81074 14.3316 8.70002C14.35 8.51684 14.2164 8.35343 14.0332 8.33503C13.8501 8.31662 13.6866 8.45019 13.6682 8.63337Z",
          fill: "#8F5715"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 10L13.3334 12H12V10Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagGuAsset = forwardRef(FlagGuAsset);

export { VpFlagGuAsset as default };
